import React from 'react'
import DropdownField from 'core/components/validatedForm/DropdownField'
import Dropdown from 'core/elements/dropdown/Dropdown'
import { RebalancingFrequency } from './model'

const items = [
  {
    label: `Default (${RebalancingFrequency.Default} minutes)`,
    value: RebalancingFrequency.Default,
  },
  {
    label: `Aggressive (${RebalancingFrequency.Aggressive} minutes)`,
    value: RebalancingFrequency.Aggressive,
  },
  {
    label: `Conservative (${RebalancingFrequency.Conservative} minutes)`,
    value: RebalancingFrequency.Conservative,
  },
]

interface Props {
  value: RebalancingFrequency
  onChange: (value: RebalancingFrequency) => void
  className?: string
}

export default function RebalancingFrequencyPickList({ value, onChange, className }: Props) {
  return (
    <DropdownField
      id="rebalancingFrequency"
      label="Rebalancing Frequency"
      value={value}
      onChange={onChange}
      items={items}
      DropdownComponent={Dropdown}
      className={className}
      required
    />
  )
}
